module.exports = __webpack_public_path__ + "images/avatars/male/3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/3.png
// module id = hB9q
// module chunks = 151